let language = {
    DETAIL_INTEGRATION_TITLE: "产品集成",
    DETAIL_INTEGRATION_DESCRIBE: "产品集成是收集符合您需求的产品信息并生成特定产品的过程。现有的产品集成主要用于 API 产品。在这个阶段，API 产品必须通过相关接口进行集成。有关 API 集成的更多信息，请参阅相关文档。",
    DETAIL_DETAILS_NAME: "详细信息",
    DETAIL_INTEGRATION_TITLE_1: "简单 PC 订购",
    DETAIL_INTEGRATION_DESCRIBE_1: "在 API 集成后，可以使用简单 PC 订购功能。用户可以在简单 PC 订购中添加 API 产品的定制信息（定制面、定制图片等）、地址信息和 SKU 产品 ID。",
    DETAIL_INTEGRATION_TITLE_2: "产品定制数据",
    DETAIL_INTEGRATION_DESCRIBE_2: "产品定制数据：用户需要在简单 PC 订购中提供所有定制面的图片或设计。简单 PC 订购的参数包括 ‘定制面’、‘材料路径’、‘图片’ 等。图片指用户提供的定制图片或设计；材料路径指材料配置路径，可以为空。",
    DETAIL_INTEGRATION_TITLE_3: "简单 PC 订购参考",
    DETAIL_INTEGRATION_HEAD_1: "变量",
    DETAIL_INTEGRATION_HEAD_2: "类型",
    DETAIL_INTEGRATION_HEAD_3: "是否必需",
    DETAIL_INTEGRATION_HEAD_4: "描述",
    DETAIL_INTEGRATION_body_1: "定制面",
    DETAIL_INTEGRATION_body_2: "字符串",
    DETAIL_INTEGRATION_body_3: "是",
    DETAIL_INTEGRATION_body_4: "定制产品的名称。名称必须与特定的定制面对齐。",
    DETAIL_INTEGRATION_body_5: "材料路径",
    DETAIL_INTEGRATION_body_6: "字符串",
    DETAIL_INTEGRATION_body_7: "否",
    DETAIL_INTEGRATION_body_8: "产品材料地址",
    DETAIL_INTEGRATION_body_9: "图片",
    DETAIL_INTEGRATION_body_10: "字符串",
    DETAIL_INTEGRATION_body_11: "是",
    DETAIL_INTEGRATION_body_12: "产品定制图片。图片必须与定制区域对齐。（由用户提供）",
    DETAIL_INTEGRATION_TITLE_4: "定制产品数据",
    DETAIL_INTEGRATION_TITLE_5: "定制面",
    DETAIL_INTEGRATION_TITLE_6: "材料路径",
    DETAIL_IMAGE_TITLE: "例如："
};

export { language }
